import HeaderTemplate from '@/templates/Header.template';
import PageSectionTemplate from '@/templates/PageSection.template';
import SectionCalendars from '@/templates/booking-rules/section-calendars/section-calendars.view';
import SectionLimits from '@/templates/booking-rules/section-limits/section-limits.view';
import SectionPTO from '@/templates/booking-rules/section-pto/section-pto.view';
import SectionSchedule from '@/templates/booking-rules/section-schedule/section-schedule.view';
import IResource from '@/types/IResource';
import IResourceGroup from '@/types/IResourceGroup';
import {
	Box,
	Button,
	FormControl,
	FormLabel,
	Heading,
	Input,
	Menu,
	MenuButton,
	MenuDivider,
	MenuItem,
	MenuList,
	VStack,
} from '@chakra-ui/react';
import { FiLock, FiTrash, FiUnlock } from 'react-icons/fi';
import { VscChevronDown, VscChevronLeft } from 'react-icons/vsc';
import { useAvailabilityDetailsController } from './availability-details-success.controller';
import SectionCollaborators from './components/collaborators/collaborators-section.view';

interface IResourceDetailsSuccessPageArgs {
	resource: IResource;
	resourceGroups: IResourceGroup[];
}

export default function ResourceDetailsSuccessPage(props: IResourceDetailsSuccessPageArgs) {
	const {
		organizationsQuery,
		t,
		handleBlockClick,
		handleUnBlockClick,
		handleSave,
		goBack,
		handleBlur,
		handleBookingRulesChanged,
		handleRemove,
		register,
	} = useAvailabilityDetailsController(props);

	return (
		<PageSectionTemplate>
			<HeaderTemplate
				left={
					<Button aria-label={t('Back')} variant="ghost" size="sm" onClick={goBack} leftIcon={<VscChevronLeft />}>
						{t('Back')}
					</Button>
				}
				center={props.resource.name}
				right={
					<Menu>
						<MenuButton as={Button} colorScheme="primary" size="sm" rightIcon={<VscChevronDown />}>
							{t('Actions')}
						</MenuButton>
						<MenuList>
							{props.resource.tags?.tt_blocked ? (
								<MenuItem icon={<FiUnlock />} onClick={handleUnBlockClick}>
									{t('Unblock')}
								</MenuItem>
							) : (
								<MenuItem icon={<FiLock />} onClick={handleBlockClick}>
									{t('Block')}
								</MenuItem>
							)}
							<MenuDivider />
							<MenuItem icon={<FiTrash />} onClick={handleRemove}>
								{t('Delete')}
							</MenuItem>
						</MenuList>
					</Menu>
				}
			/>

			{props.resource.tags?.tt_blocked ? (
				<VStack my={4} gap={8}>
					<Box>
						<FiLock size={30} />
					</Box>

					<Heading textAlign="center" size="sm">
						{props.resource.tags?.tt_blocked}
					</Heading>
				</VStack>
			) : (
				<Box overflow="auto">
					<FormControl id="name" my={4}>
						<FormLabel>{t('Availability name')}</FormLabel>
						<Input
							w="full"
							aria-label={t('Name')}
							{...register('name')}
							type="text"
							variant="filled"
							onBlur={handleBlur}
						/>
					</FormControl>

					<FormLabel mt={8} mb={4}>
						{t('Choose when you want to be available for bookings.')}
					</FormLabel>
					<SectionSchedule bookingRules={props.resource.bookingRules} onChange={handleBookingRulesChanged} />
					<SectionLimits bookingRules={props.resource.bookingRules} onChange={handleBookingRulesChanged} />
					<SectionCalendars bookingRules={props.resource.bookingRules} onChange={handleBookingRulesChanged} />
					<SectionPTO bookingRules={props.resource.bookingRules} onChange={handleBookingRulesChanged} />
					{organizationsQuery.data ? (
						<SectionCollaborators
							onChange={handleSave}
							organizations={organizationsQuery.data.organizations}
							resource={props.resource}
						/>
					) : null}
				</Box>
			)}
		</PageSectionTemplate>
	);
}
